// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__IgKiH","stacked-backdrop":"Modal_stacked-backdrop__6QXy0","parent":"Modal_parent__2MLBQ","fade":"Modal_fade__zrl3s","modal":"Modal_modal__aC6rU"};